import { optiMutation } from './base';

export const useGerarAnaliseLegibilidade = () => {
  return optiMutation(`/plugin/artigos/analise-legibilidade`, 'post', null);
};

export const useGerarAnaliseLegibilidadeVozPassiva = () => {
  return optiMutation(`/plugin/artigos/analise-voz-passiva`, 'post', null);
};

export const useGerarAnaliseLegibilidadeOrtografia = () => {
  return optiMutation(`/plugin/artigos/analise-ortografia`, 'post', null);
};

export const usegerarAnaliseLegibilidaGramatica = () => {
  return optiMutation(`/plugin/artigos/analise-gramatica`, 'post', null);
};